import axiosInstance from "../../utils/axiosInstance";

// notification
import { notify } from "../../components/alerts";
import { setCompany, setLoading } from "../../store/slices/company";
import { AppDispatch } from "../../store/store";
import {
  ICreateBranch,
  ICreateCompany,
  IJoinCompanyBranch,
} from "../../store/@types/company";
import { NavigateFunction } from "react-router-dom";
// import { isAxiosError } from "axios";

type ISearchParams = { rc_number: string };
export const getCompanyRCNumber = async (
  dispatch: AppDispatch,
  formData: ISearchParams,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/v1/search-rc-number", formData);
    dispatch(setCompany(response.data?.data));
  } catch (err: any) {}
  dispatch(setLoading());
};

export const create_company = async (
  dispatch: AppDispatch,
  form: ICreateCompany,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/v1/user-join-or-create-company",
      form,
    );

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (err) {
    // dispatch(setMessage({ type: "error", ...err.response.data }));
  }
  dispatch(setLoading());
};

export const join_branch = async (
  dispatch: AppDispatch,
  form: IJoinCompanyBranch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/v1/user-join-or-create-company",
      form,
    );

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (err) {
    // dispatch(setMessage({ type: "error", ...err.response.data }));
  }
  dispatch(setLoading());
};

export const create_branch = async (
  dispatch: AppDispatch,
  form: ICreateBranch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/v1/user-join-or-create-company",
      form,
    );

    const { message } = response.data;
    notify({ message, type: "success" });
    navigate("/dashboard");
  } catch (err) {
    // dispatch(setMessage({ type: "error", ...err.response.data }));
  }
  dispatch(setLoading());
};

export const get_company_details = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/v1/get-company-details");
    dispatch(setCompany(response.data?.data));
  } catch (err) {
    // dispatch(setMessage({ type: "error", ...err.response.data }));
  }
  dispatch(setLoading());
};

// test